export class GetSMTPByEmailResponse {
    ID: number;
    FromEmail: string;
    FromName: string;
    Name: string;
    Host: string;
    Port: number;
    Enabled: boolean;
    IsDefault: boolean;
    Username: string;
    EnableSSL: boolean;
}
